export default () => {
    const defaults = {
        'format': 'webp',
        'quality': 100,
        'fit': 'crop',
        'width': 80,
        'height': 80,
    };

    return {
        cloudflareImage: (url, params) => {
            params = Object.assign(defaults, params)
            params = Object.keys(params).map((key) => `${key}=${params[key]}`).join(',')

            return `https://codecourse.com/cdn-cgi/image/${params}/${url}`
        }
    }
}
